<template>
  <div class="center-narrow center-heading">
    <h1 class="sp-t">Choose what to show.</h1>
    <h2 class="sp-b">Images with selected tags below will appear publicly in your portfolio</h2>
    <ul class="toggle-list">
      <li v-for="tag in tags" :key="tag" @click="triggerToggle">
        <ux-toggle-icon @ontoggle="toggleTag(...arguments, tag)" :selected="getSelected(tag)"></ux-toggle-icon>
        {{tag | title}}
      </li>
    </ul>
  </div>
</template>

<script>
import UxToggleIcon from "./UxToggleIcon";
export default {
  components: { UxToggleIcon },
  data() {
    return {};
  },
  created() {},
  methods: {
    triggerToggle(ev) {
      let toggle = ev.target.querySelector(".material-icons");
      if (toggle) {
        toggle.click();
      }
    },
    toggleTag(add, tag) {
      if (add) {
        this.$store.dispatch("addTag", tag);
        return;
      }
      this.$store.dispatch("removeTag", tag);
      return;
    },
    getSelected(tag) {
      return this.$store.getters.tagState(tag);
    }
  },
  filters: {
    title(val) {
      if (!val) return "";
      val = val.toString();
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
  },
  computed: {
    filtered() {
      return this.$store.filteredTags;
    },
    tags() {
      return this.$store.getters.tags;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
